import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { MetaService } from '../meta/meta.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class IdleService implements OnDestroy {
  private idleTimeout: any;
  private timeout = 1000 * 60 * 5;
  public $idle = new BehaviorSubject<number>(null);
  private metaSub: Subscription;
  private routerSub: Subscription;
  private lastInteraction: number = 0;
  private eventListeners: Array<{ element: any, action: string, callback: any }> = [];
  private readonly boundIdleHandler = () => this.restartTimeout();

  constructor(private meta: MetaService, private router: Router) {
    this.routerSub = this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((event: any) => {
      if (event?.url?.indexOf('home/app') > -1) {
        this.stopTimeout();
      } else {
        this.startTimeout();
      }
    });

    this.metaSub = this.meta.$changed.subscribe(() => {
      const newTimeout = this.meta.getNumber('ibexTouch.screensaverTimeout', 1000 * 60 * 5);
      if (newTimeout !== this.timeout) {
        this.timeout = newTimeout;
        this.restartTimeout(true);
      }
    });
    this.restartTimeout(true);
  }

  ngOnDestroy() {
    this.stopTimeout();
    this.metaSub?.unsubscribe();
    this.routerSub?.unsubscribe();
  }

  private addEventListeners() {
    if (this.eventListeners.length > 0) return;
    ['pointerdown', 'pointermove', 'keydown', 'click', 'touchstart', 'scroll'].forEach(action => {
      window.addEventListener(action, this.boundIdleHandler, { passive: true });
      this.eventListeners.push({ element: window, action, callback: this.boundIdleHandler });
    });
  }

  private removeEventListeners() {
    this.eventListeners.forEach(l => { l.element.removeEventListener(l.action, l.callback); });
    this.eventListeners = [];
  }

  public restartTimeout(force = false) {
    const now = Date.now();
    if (!force && (now - this.lastInteraction <= 200)) {
      return;
    }
    this.lastInteraction = now;
    this.startTimeout();
  }

  public startTimeout() {
    this.addEventListeners();
    clearTimeout(this.idleTimeout);
    this.idleTimeout = setTimeout(() => { this.$idle.next(Date.now()); }, this.timeout);
  }

  public stopTimeout() {
    this.removeEventListeners();
    clearTimeout(this.idleTimeout);
  }
}
